import React__default from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { Accordion, AccordionItem, Link } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { Icon } from '@grandvisionhq/icons';
import { useIntl, useSelector } from '@grandvisionhq/state';
import BillingAddressContainer from './components/BillingAddress/BillingAddressContainer.js';
import PersonalDetailsContainer from './components/PersonalDetails/PersonalDetailsContainer.js';
import PersonalGreeting from './components/PersonalGreeting/PersonalGreeting.js';
import PreferredStoreContainer from './components/PreferredStore/PreferredStoreContainer.js';
import RecentOrders from './components/RecentOrders/RecentOrders.js';
import Support from './components/Support/Support.js';
import UpcomingAppointments from './components/UpcomingAppointments/UpcomingAppointments.js';

const Profile = ({ isAABEnabled  })=>{
    var ref;
    const { href: settingsRoute  } = (ref = useLink({
        route: 'me.settings'
    })) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const { href: ordersRoute  } = (ref1 = useLink({
        route: 'me.orders'
    })) !== null && ref1 !== void 0 ? ref1 : {};
    const intl = useIntl();
    const auth = useSelector(Selectors.getAuth);
    if (auth.type !== 'regular') {
        throw new Error(`Can't look at the Profile page with passwordless login`);
    }
    const getProfileSections = ()=>{
        const openSections = [
            0
        ];
        const sections = [];
        // creating sections-array for myProfile
        if (isAABEnabled) {
            sections.push({
                title: intl.getLabel('account.appointments.title'),
                body: /*#__PURE__*/ React__default.createElement(UpcomingAppointments, null)
            });
            openSections.push(1);
        }
        //some opco do not have e-comm yet, so skip orders section
        if (ordersRoute) {
            sections.push({
                title: intl.getLabel('account.profile.recentOrders.title'),
                body: /*#__PURE__*/ React__default.createElement(RecentOrders, null)
            });
        }
        if (!auth.disableAddressEditing) {
            sections.push({
                title: intl.getLabel('account.billingAddress'),
                body: /*#__PURE__*/ React__default.createElement(BillingAddressContainer, null)
            });
        }
        sections.push({
            title: intl.getLabel('account.profile.personalDetails'),
            body: /*#__PURE__*/ React__default.createElement("div", {
                className: "myaccount-profile__personal-details"
            }, /*#__PURE__*/ React__default.createElement(PersonalDetailsContainer, {
                showIntro: true
            }), /*#__PURE__*/ React__default.createElement(Link, {
                href: settingsRoute
            }, intl.getLabel('account.profile.personalDetails.link'), /*#__PURE__*/ React__default.createElement(Icon, {
                className: "myaccount-profile__personal-details__icon",
                name: "chevron-right"
            })))
        }, {
            title: intl.getLabel('account.profile.preferredStore'),
            body: /*#__PURE__*/ React__default.createElement("div", {
                className: "section__body preferred-store"
            }, /*#__PURE__*/ React__default.createElement(PreferredStoreContainer, null))
        });
        return /*#__PURE__*/ React__default.createElement(Accordion, null, sections.map((section, i)=>/*#__PURE__*/ React__default.createElement(AccordionItem, {
                key: i,
                id: section.title.replace(' ', '-'),
                label: section.title,
                expanded: openSections.includes(i)
            }, section.body)
        ), /*#__PURE__*/ React__default.createElement(Support, null));
    };
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "myaccount-profile"
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, /*#__PURE__*/ React__default.createElement(PersonalGreeting, null)), /*#__PURE__*/ React__default.createElement(Text, null, intl.getLabel('account.profile.intro')), getProfileSections());
};
var Profile$1 = Profile;

export { Profile, Profile$1 as default };
//# sourceMappingURL=Profile.js.map
